var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "trade-dialog", style: _vm.dialogStyle }, [
    _c("div", { staticClass: "header" }, [
      _c("p", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("p", { staticClass: "close-icon", on: { click: _vm.closeClick } }, [
        _c("img", { attrs: { src: _vm.closeIcon } })
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "content" }, [
      _vm.currentStep == 0
        ? _c("div", { staticClass: "step" }, [
            _c(
              "div",
              { staticClass: "select-list" },
              [
                _c("ui-select", {
                  attrs: {
                    title: _vm.accountTitle,
                    model: _vm.accountModel,
                    options: _vm.tradeAccounts,
                    "select-style": _vm.selectStyle,
                    "font-style": _vm.fontStyle,
                    "list-style": _vm.listStyle,
                    "list-item-style": _vm.listItemStyle
                  },
                  on: { "change-select": _vm.changeTradeAccount }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("p", { staticClass: "trade-item" }, [
              _c("span", { staticClass: "title" }, [_vm._v("交易品种")]),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.tradeInfo.name))
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "trade-item" }, [
              _c("span", { staticClass: "title" }, [_vm._v("交易方向")]),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.tradeInfo.cmd))
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "select-list" },
              [
                _c("ui-select", {
                  attrs: {
                    title: _vm.methodTitle,
                    model: _vm.methodModel,
                    options: _vm.methods,
                    "select-style": _vm.selectStyle,
                    "font-style": _vm.fontStyle,
                    "list-style": _vm.listStyle,
                    "list-item-style": _vm.listItemStyle
                  },
                  on: { "change-select": _vm.changeCommissionMethod }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "input" },
              [
                _c("ui-input", {
                  attrs: {
                    title: _vm.volumeTitle,
                    "font-style": _vm.fontStyle,
                    "input-style": _vm.inputStyle,
                    model: _vm.tradeVolume
                  },
                  on: { "change-input": _vm.changeTradeVolume }
                }),
                _vm._v(" "),
                _vm.showMsgErr
                  ? _c("p", { staticClass: "msg" }, [
                      _vm._v(_vm._s(_vm.volumeErr))
                    ])
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c("button", { on: { click: _vm.confirmClick } }, [
                _vm._v("确定")
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 1
        ? _c("div", { staticClass: "step" }, [
            _c("p", { staticClass: "warn-msg" }, [
              _vm._v("以下是您的交易信息，请确认:")
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "trade-item" }, [
              _c("span", { staticClass: "title" }, [_vm._v("交易账户")]),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.tradeInfo.accountNo) +
                    "\n                    "
                ),
                parseInt(_vm.tradeInfo.accountType) == 1
                  ? _c("span", { staticClass: "type" }, [_vm._v("(虚拟账户)")])
                  : _vm._e(),
                _vm._v(" "),
                parseInt(_vm.tradeInfo.accountType) == 2
                  ? _c("span", { staticClass: "type" }, [_vm._v("(真实账户)")])
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "trade-item" }, [
              _c("span", { staticClass: "title" }, [_vm._v("交易品种")]),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.tradeInfo.name))
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "trade-item" }, [
              _c("span", { staticClass: "title" }, [_vm._v("交易方向")]),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.tradeInfo.cmd))
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "trade-item" }, [
              _c("span", { staticClass: "title" }, [_vm._v("委托方式")]),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.commissionMethod))
              ])
            ]),
            _vm._v(" "),
            _c("p", { staticClass: "trade-item" }, [
              _c("span", { staticClass: "title" }, [_vm._v("委托手数")]),
              _vm._v(" "),
              _c("span", { staticClass: "name" }, [
                _vm._v(_vm._s(_vm.tradeVolume))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn" }, [
              _c("button", { on: { click: _vm.secondStepConfirm } }, [
                _vm._v("确定")
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.currentStep == 2
        ? _c("div", { staticClass: "step" }, [
            _vm.showLoading
              ? _c(
                  "div",
                  { staticClass: "step-content show-loading" },
                  [_c("loading")],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.orderSuccess && !_vm.showLoading
              ? _c("div", { staticClass: "step-content" }, [
                  _c("img", {
                    staticClass: "icon",
                    attrs: { src: _vm.successIcon }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "msg" }, [_vm._v("下单成功")]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "scan-trade",
                      on: { click: _vm.scanMyTrade }
                    },
                    [_vm._v("查看我的交易")]
                  )
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.orderSuccess && !_vm.showLoading
              ? _c("div", { staticClass: "step-content" }, [
                  _c("img", {
                    staticClass: "icon",
                    attrs: { src: _vm.failIcon }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "msg" }, [_vm._v("下单失败")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "fail-info" }, [
                    _vm._v("失败原因:" + _vm._s(_vm.failMsg))
                  ])
                ])
              : _vm._e()
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9afff2ee", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9afff2ee","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/dialog/tradeDialog.vue
// module id = 526
// module chunks = 0 1